import { render, staticRenderFns } from "./SDKListLess.vue?vue&type=template&id=24af5ed3&scoped=true"
import script from "./SDKListLess.vue?vue&type=script&lang=js"
export * from "./SDKListLess.vue?vue&type=script&lang=js"
import style0 from "./SDKListLess.vue?vue&type=style&index=0&id=24af5ed3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24af5ed3",
  null
  
)

export default component.exports